var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-lg mx-auto md:text-center"},[_c('h2',[_vm._t("title")],2),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }